import React, { useEffect, useState, useCallback } from "react";
import IndexComponent from "./Index.component";
import { getCastingSummary } from "api/student/v2/casting.api";
import { usePopup } from "contexts/PopupContext";
import StudentInfoPopupContainer from "commons/student/popup/StudentInfoPopup.container";

const IndexContainer = () => {
    const { showPopup } = usePopup();

    interface ICastingSummary {
        totalFavoriteCount: number;

        totalChattingCount: number;
        waitingChattingCount: number;
        canceledChattingCount: number;
        deniedChattingCount: number;
        onChattingCount: number;
        closedChattingCount: number;

        totalViewCount: number;
        todayViewCount: number;
        weeklyViewCount: number;
        monthlyViewCount: number;

        traineeList?: Array<any>;
    }

    //* 캐스팅 요약페이지 조회
    // const [castingSummary, setCastingSummary] = useState
    const [isLoading, setIsLoading] = useState(true);
    const [info, setInfo] = useState<ICastingSummary | null>(null);

    useEffect(() => {
        //* 캐스팅 요약페이지 조회
        fetchCastingSummary();
    }, []);

    const fetchCastingSummary = async () => {
        try {
            const data = await getCastingSummary();
            if (data?.info) {
                setInfo(data.info);
            }
        } catch (error: any) {
            console.error('Failed to fetch casting summary:', error);
            alert(error?.message || "Failed to fetch casting summary");
        } finally {
            setIsLoading(false);
        }
    }

    const handleShowStudentInfoPopup = useCallback((studentId: number) => {
        showPopup(<StudentInfoPopupContainer
            studentId={studentId} />);
    }, []);

    return <IndexComponent
        info={info}
        isLoading={isLoading}
        handleShowStudentInfoPopup={handleShowStudentInfoPopup}
    />;
};

export default IndexContainer;